import Vue from "vue";
import Component from "vue-class-component";
import { modalHelper, IModalBase, DataItem, alertHelper } from "@/components";
import { Deferred } from "@/utils/Deferred";
import { usersStore } from "../store/users.store";
import { Prop, Watch } from "vue-property-decorator";
import { Async } from "@/utils/AsyncDecorators";

import { accountService } from '@/services/accountService';
import { rolesStore } from '../store/roles.store';
import { localizeFunction } from '@/filters/localizeFilter';
import { Guid } from 'guid-typescript';
import { toastHelper } from '@/helpers/ToastHelper';
import { usersService } from "../services/usersService";
@Component({})
export default class GenerateInternalCredential extends Vue implements IModalBase<server.user> {
  @Prop()
  value: server.user;

  @Prop()
  deferred: Deferred<DataItem<server.user>>;
  msg: string = "";

  @Async({ async get() { return await rolesStore.getters.getAll(); }, default: [], lazy: false })
  roles: server.role[] = [];


  internalUser: server.auth.internalCredentials = null;
  mounted() {
    this.internalUser = {
      id: (this.value?.id) || null,
      firstName: (this.value?.firstName) || null,
      lastName: (this.value?.lastName) || null,
      userName: (this.value?.userName) || null,
      lockoutEnabled: (this.value?.lockoutEnabled) || false,
      roles: (this.value?.roles) || [],
      password: null,
    };
    setTimeout(this.validateForm, 2000); 
  }

  @Watch("value")
  changeInternalUser() {
    if(this.internalUser != null){
      this.internalUser.id = (this.value?.id) || null;
      this.internalUser.firstName = (this.value?.firstName) || null;
      this.internalUser.lastName = (this.value?.lastName) || null;
      this.internalUser.userName = (this.value?.userName) || null;
      this.internalUser.lockoutEnabled = (this.value?.lockoutEnabled) || false;
      this.internalUser.roles = (this.value?.roles) || [];
      this.internalUser.password = null;
    }
  };

  formIsValid: boolean = false;
  validateForm() {
    this.formIsValid = (this.$refs.form && (this.$refs.form as any).checkValidity())
  }

  get defaultUserName(): string {
    var result = "";
    if(this.internalUser != null){
      if (this.internalUser.firstName) {
        result += this.internalUser.firstName.toLowerCase().replace(/' '/gi, "-");
      }
      if (this.internalUser.lastName) {
        if (this.internalUser.firstName) {
          result += ".";
        }
        result += this.internalUser.lastName.toLowerCase().replace(/' '/gi, "-");
      }
    }
    return result;
  }

  @Watch("defaultUserName")
  defaultUserNameChange(n: string, o: string) {
    if (!this.internalUser.userName || this.internalUser.userName === o) {
      this.internalUser.userName = n;
    }
  }

  async generateCredential() {
    if (!this.internalUser.id) this.internalUser.id = Guid.create().toString();
    const result = await accountService.InternalCredentials(this.internalUser);
    if (result) {
      this.value.id = result.id;
      this.internalUser.id = result.id;
      this.internalUser.password = result.password;
      await usersStore.getters.getAll();
    }
  }

  async ok() {
    Object.assign(this.value, await usersStore.getters.get(this.value.id));
    this.value.lockoutEnabled = this.internalUser.lockoutEnabled;
    this.value.roles = this.internalUser.roles;
    await usersStore.actions.setUtenti(this.value);
    modalHelper.Changed(this);
    if(this.value.id) usersService.Set(this.value, this.value.id)
  }

  async remove() {
    if (await alertHelper.show(localizeFunction('confirm-delete', `Sei sicuro di voler cancellare l'elemento corrente?`))) {
      try {
        await usersStore.actions.remove(this.value);
        modalHelper.Deleted(this);
      } catch (e) {
        if (e && e.response && e.response.status == 412) toastHelper.error('Impossibile cancellare elemento, sono presenti uno o più vincoli che ne impediscono la cancellazione.')
        modalHelper.Unchanged(this);
      }

    } else {
      modalHelper.Unchanged(this);
    }
  }

  cancel() {
    modalHelper.Unchanged(this);
    modalHelper.closeModal("extended");
  }
}